import React, { useState } from "react"
import type { Course } from "../../../proto/qf/types_pb"
import { Color } from "../../Helpers"
import { useActions, useAppState } from "../../overmind"
import CourseForm from "../forms/CourseForm"
import CourseCreationInfo from "./CourseCreationInfo"


const CreateCourse = () => {
    const state = useAppState()
    const actions = useActions().global
    const [course, setCourse] = useState<Course>()
    const [orgName, setOrgName] = useState("")

    const refresh = React.useCallback(async () => {
        await actions.getCourses()
        const c = state.courses.find(c => c.ScmOrganizationName === orgName)
        if (c) {
            await actions.getEnrollmentsByUser()
            setCourse(c)
        } else {
            actions.alert({ text: "Course not found. Make sure the organization name is correct and that you have installed the GitHub App.", color: Color.YELLOW, delay: 10000 })
        }
    }, [actions, orgName, state.courses])

    const buttonClass = course ? "btn btn-success btn-disabled" : "btn btn-primary"
    const findTextOrIcon = course ? <i className="fas fa-check" /> : "Find"
    const refreshIfNoCourse = course ? undefined : refresh
    return (
        <div className="container mx-auto px-4 space-y-6">
            <CourseCreationInfo />
            <div className="join w-full">
                <span className="join-item btn btn-neutral no-animation cursor-default">Get Course</span>
                <input
                    className="input input-bordered join-item flex-1"
                    disabled={course ? true : false}
                    onKeyUp={e => setOrgName(e.currentTarget.value)}
                    placeholder="Organization name"
                />
                <button
                    className={`${buttonClass} join-item`}
                    onClick={refreshIfNoCourse}
                >
                    {findTextOrIcon}
                </button>
            </div>
            {course ? <CourseForm courseToEdit={course} /> : null}
        </div>
    )
}

export default CreateCourse
